export const BUSINESS_ACCOUNT_ID = '17841405597364990';

export const getRecipientId = (conversation, businessAccountId = BUSINESS_ACCOUNT_ID) => {
  const participants = conversation?._raw?.participants?.data;
  if (participants && Array.isArray(participants)) {
    const recipient = participants.find((p) => p.id !== businessAccountId);
    if (recipient?.id) return recipient.id;
  }

  if (conversation?.sender?.id) {
    return conversation.sender.id !== businessAccountId ? conversation.sender.id : null;
  }

  return conversation?.conversationId || null;
};

export const getRecipientInfo = (conversation, businessAccountId = BUSINESS_ACCOUNT_ID) => {
  const participants = conversation?._raw?.participants?.data;
  if (participants && Array.isArray(participants)) {
    const recipient = participants.find((p) => p.id !== businessAccountId);
    if (recipient) {
      return {
        id: recipient.id,
        username: recipient.username || recipient.name,
      };
    }
  }

  if (conversation?.sender?.id) {
    if (conversation.sender.id !== businessAccountId) {
      return {
        id: conversation.sender.id,
        username: conversation.sender.username || conversation.sender.name,
      };
    }
  }

  return null;
};

export const isOutgoingMessage = (message, businessAccountId = BUSINESS_ACCOUNT_ID) => {
  return message?.from?.id === businessAccountId;
};
